import React from "react";
import "./com_4.css";
import { Check } from "lucide-react"; // for check icons (install lucide-react if not already)

const VisionMission = () => {
  return (
    <section className="vision-mission-section">
      <div className="vision-mission-container">
        {/* Vision */}
        <div className="vision-box">
          <h2>OUR VISION</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur. Pellentesque nascetur sed
            tellus ut vehicula eu consectetur elit at. Nulla eu mattis nisl
            etiam sed semper vitae. Tempor odio ullamcorper non sed dignissim
            eu egestas fusce arcu.
          </p>
        </div>

        {/* Mission */}
        <div className="mission-box">
          <h2>OUR MISSION</h2>
          <ul>
            <li>
              <Check className="icon" />
              Lorem ipsum dolor sit amet consectetur elementum nascetur sed.
            </li>
            <li>
              <Check className="icon" />
              Lorem ipsum dolor sit amet consectetur elementum nascetur sed.
            </li>
            <li>
              <Check className="icon" />
              Lorem ipsum dolor sit amet consectetur elementum nascetur sed.
            </li>
            <li>
              <Check className="icon" />
              Lorem ipsum dolor sit amet consectetur elementum nascetur sed.
            </li>
          </ul>
        </div>
      </div>
      <div className="orange-line"></div>
    </section>
  );
};

export default VisionMission;
